module.exports = __webpack_public_path__ + "img/m3_t1_bg.719fa8a3.svg";